import { useMemo } from "react";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { formatCardsRanks } from "utils/loyalty";
import { RANK_LEVEL_LOYALTY_IMAGES } from "constants/loyalty";
import { LoyaltyCarousel } from "components/atoms/LoyaltyCarousel";
import "./styles.sass";

const LoyaltyCarouselContainer = () => {
  const { data: loyaltyData } = useGetLoyaltyUser();
  const { data: progressData } = useGetProgressLoyalty();
  const userExperience = progressData?.data?.data?.experience || 0;

  const { cards, indexCurrentRank } = useMemo(
    () => formatCardsRanks(userExperience, loyaltyData?.data?.data),
    [loyaltyData?.data?.data, userExperience],
  );

  const currentRank = cards?.[0]?.nameRank || "";
  const activeCardIndex = cards.findIndex((card) => card.isActive) || 0;
  const activeIndex = activeCardIndex < 0 ? 0 : activeCardIndex;
  const rankImage = RANK_LEVEL_LOYALTY_IMAGES[indexCurrentRank].rank;
  return (
    <div className="LoyaltyCarouselContainer">
      <LoyaltyCarousel
        cards={cards}
        rank={currentRank}
        defaultIndex={activeIndex}
        rankImage={rankImage}
        showWelcome={indexCurrentRank === 0}
      />
    </div>
  );
};
export default LoyaltyCarouselContainer;
